import IpBlack from '../../pages/ip_black'

const IpBlackRoute = [
  {
    path: '/ip_black',
    name: 'ip_black',
    component: IpBlack
  }
]

export default IpBlackRoute



// WEBPACK FOOTER //
// ./src/router/ip_black/index.js